import { render } from "./Section_Land.vue?vue&type=template&id=7b3d4d7b"
import script from "./Section_Land.vue?vue&type=script&lang=js"
export * from "./Section_Land.vue?vue&type=script&lang=js"

import "./Section_Land.vue?vue&type=style&index=0&id=7b3d4d7b&lang=scss"
script.render = render

export default script